import styled from "styled-components";
import Joyride from "react-joyride";

type JourneyType = {
    color: string;
}

export const JourneyStyled = styled(Joyride)<JourneyType>`

`;
